import React from 'react';
import { signOutAndRedirect } from '../../api/axios';

/**
 * Quiet "Sign out" in the top-right corner of the full-screen pickers
 * (workspace and staff). Those screens have no nav, so without this an account
 * with nowhere to go — no workspaces, no support grants — has no way out.
 */
const PickerSignOutButton: React.FC = () => (
  <button
    type="button"
    className="picker-signout"
    onClick={() => { void signOutAndRedirect(); }}
    title="Sign out"
  >
    <i className="fas fa-right-from-bracket" aria-hidden="true" />
    Sign out
  </button>
);

export default PickerSignOutButton;
